<template>
  <div v-show="pageDesc" style="display: flex; align-items: center">
    <ElIcons class="desc-iocn" name="QuestionFilled" @click="showDesc"/>
  </div>
</template>

<script>
import showDesc from "@/components/showDesc";
import Dialog from "@/assets/js/dialog";
export default {
  name: "pageDesc",
  data() {
    return {
      pageDesc: '',
      // menuId: '',
      title: '',
      url: ''
    }
  },
  methods: {
    showDesc() {
      Dialog.open({
        title: this.title,
        component: showDesc,
        data: {
          width: '500px',
          pageDesc: this.pageDesc
        },
        confirm: () => {
        }
      })
    },

    // getQueryString(name) {
    //   var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    //   var r = window.location.search.substr(1).match(reg);
    //   if (r != null) return unescape(r[2]);
    //   return null;
    // },

    getDesc() {
      // let menuId = this.getQueryString('menuId')
      let url = this.$route.path
      let menuList = JSON.parse(localStorage.getItem('menuList'))
      menuList.map(item => {
        if(item.children != null) {
          item.children.map(c => {
            if(c.url == url) {
              this.pageDesc = c.pageDesc
              this.title = c.name
            }
          })
        }else {
          if(item.url == url) {
            this.pageDesc = item.pageDesc
            this.title = item.name
          }
        }
      })
    }

  },
  mounted() {
    this.getDesc()

  }
}
</script>

<style scoped>
.desc-iocn {
  margin-left: 4px;
  cursor: pointer;
  color: #bbbbbb;
}
.desc-iocn:hover {
  color: #3a8ee6;
}
</style>
